import { RootState } from "lib/store";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import { Container, Link } from "@/atoms";
import { Fragment } from "react";
import { closePopUp } from "@/lib/cartPopUp";


export const PopUpCart = () => {
    const dispatch = useDispatch();
    const cartPopUp = useSelector((state: RootState) => state.cartPopUp);
    return (cartPopUp.visible ?
        <Transition appear show={cartPopUp.visible} as={Fragment}>
            <Dialog
                as="div"
                className="fixed inset-0 z-10 overflow-y-auto"
                onClose={() => dispatch(closePopUp())}
            >
                <div className="min-h-screen px-4 text-center md:w-full bg-black bg-opacity-30 h-full flex justify-center items-center">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Dialog.Overlay className="fixed inset-0" />
                    </Transition.Child>

                    <span
                        className="inline-block md:h-screen align-middle"
                        aria-hidden="true"
                    >
                        &#8203;
                    </span>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 scale-95"
                        enterTo="opacity-100 scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 scale-100"
                        leaveTo="opacity-0 scale-95"
                    >
                        <div className="my-20 md:my-8 inline-block md:w-[800px] h-fit transform  bg-primary-100 text-left align-middle shadow-xl transition-all">
                            <div className="flex flex-col md:flex-row">
                                <div className="w-full h-auto md:w-full p-6 pt-0">
                                    <Container
                                        wrapper
                                        padding="pt-2"
                                        backgroundColor="bg-primary-100"
                                    >
                                        <div className="modal-header flex flex-shrink-0 justify-end">
                                            <button
                                                type="button"
                                                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                                                data-bs-dismiss="modal"
                                                aria-label="Close"
                                                onClick={() => dispatch(closePopUp())}
                                            >
                                                x
                                            </button>
                                        </div>
                                        <div className="grid col-span-2">
                                            <p className="text-headline text-headline--h2 text-text-primary mt-3">
                                                Ha excedido el límite de piezas
                                            </p>
                                            <p className="ext-subtitle text-subtitle--l text-body text-body--m mt-5">
                                                El límite de piezas que puede añadir al carrito es de 10 unidades. <br /> Si desea comprar más unidades pongase en contacto con nosotros llamando al <Link largerFont className="md:text-sm" href="tel:91 503 63 34">91 503 63 34</Link>
                                            </p>
                                        </div>
                                    </Container>
                                </div>
                            </div>
                        </div>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition>
        : <></>
    );
};

export default PopUpCart;
